import React, { FC } from 'react'
import "./anchor-link.css";

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode,
    disabled?: boolean,
    padding?: boolean
 }

const AnchorLink: FC<Props> = (props) => {
    const { className: classProps, children, disabled = false, padding = false, ...divProps } = props
    const className = flatten('anchor-link', disabled ? 'disabled' : '', padding ? 'padding' : '', classProps)

    return <div className={className} {...divProps}>{children}</div>
}

export default AnchorLink
